import { useTranslation } from "react-i18next";

import { ReactComponent as Player } from "../../static/images/user_icon.svg";
import { ReactComponent as Email } from "../../static/images/email.svg";
import { ReactComponent as Dial } from "../../static/images/dial-icon.svg";

import "./style.scss";

const PlayerDetails = ({ playerName, number, email, changeModal }) => {
  const { t } = useTranslation();

  return (
    <div className={`player-details-container`}>
      <div className="details-content">
        <div className="icon">
          <Player />
        </div>
        <div className="player-name">
          <h3>{playerName}</h3>
        </div>
        <div className="player-contacts">
          {number ? (
            <div className="player-number">
              <a href={`tel:${number}`}> {"+" + number}</a>
              <Dial />
            </div>
          ) : null}
          {email ? (
            <div className="player-email">
              <a href={`mailto:${email}`}>{email}</a>
              <Email />
            </div>
          ) : null}
        </div>

        <div className="player-details-button">
          <button
            onClick={() => {
              changeModal(false);
            }}
          >
            {t("close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlayerDetails;
